export class NotificationReadRequest {

    _notificationIds; // number[]

    constructor() {
        this._notificationIds = [];
    }

    setNotifications(notifications) {
        this._notificationIds = notifications.map((notification) => notification.id());
    }

    body() {
        return {
            notificationIds: this._notificationIds,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/notifications/preview-list/notification-read/NotificationReadRequest.js